'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user-helmet-safety';
var width = 448;
var height = 512;
var aliases = [128119,"user-construction","user-hard-hat"];
var unicode = 'f82c';
var svgPathData = ['M144 144c0 44.2 35.8 80 80 80s80-35.8 80-80l-160 0z', 'M216-32c-13.3 0-24 10.7-24 24l0 72-8 0c-13.3 0-24-10.7-24-24l0-46.9C123.9 14 99 52 96.2 96L96 96c-13.3 0-24 10.7-24 24s10.7 24 24 24c0 70.7 57.3 128 128 128s128-57.3 128-128c13.3 0 24-10.7 24-24s-10.7-24-24-24l-.2 0C349 52 324.1 14 288-6.9L288 40c0 13.3-10.7 24-24 24l-8 0 0-72c0-13.3-10.7-24-24-24l-16 0zm88 176c0 44.2-35.8 80-80 80s-80-35.8-80-80l160 0zM180.6 320C89.7 320 16 393.7 16 484.6 16 499.7 28.3 512 43.4 512l361.1 0c15.1 0 27.4-12.3 27.4-27.4 0-90.9-73.7-164.6-164.6-164.6l-86.9 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserHelmetSafety = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;